import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useMutation } from "@tanstack/react-query";
import postSiteLogPreview from "../http/postSiteLogPreview";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const usePreviewChangelog = () => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  return useMutation(async (params: { siteId: string; update: any }) =>
    postSiteLogPreview(
      await getAuthTokenBlocking(getToken, relogin),
      params.siteId,
      params.update
    )
  );
};

export default usePreviewChangelog;
